"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadAppointmentGaps = exports.getNextAppointment = exports.getAppointmentId = exports.getAppointmentGapList = exports.findAllAppointmentIds = exports.deleteAppointment = void 0;
exports.saveAppointment = saveAppointment;
exports.saveAppointmentWish = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _GermanDateHelpers = require("../../utils/GermanDateHelpers");
var _RestHelper = _interopRequireWildcard(require("../../utils/RestHelper"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
/*
GET     contractaccounts/{contractAccountId}/appointments/{assOrderId}
Response:
{
  "isDatePlannable": false,
  "isDateCancellable": false,
  "isDateRequestable": true,
  "appointment": {
    "from": "2022-01-11T06:30:00.000Z",
    "to": "2022-01-11T10:15:00.000Z"
  },
  "meterInstallationServiceProvider": {
    "name": "SupInfo AN",
    "phone": "0815"
  },
  "blocked": [
    {
      "from": "2021-11-15T00:00:00.000Z",
      "to": "2022-01-04T00:00:00.000Z"
    }
  ]
}
*/
var getNextAppointment = exports.getNextAppointment = function getNextAppointment(contractAccountId, appointmentOrderId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/contractaccounts/").concat(contractAccountId, "/appointments/").concat(appointmentOrderId));
};

/*
GET     /appointments
Response:
{
    content:[
        {
            "contractAccountId": "21655756747",
            "assOrderId":[ "000815","121333" ]
        },
        {
            "contractAccountId": "216557534343",
            "assOrderId":[ "000815","44444" ]
        }
    ]
}
*/
var findAllAppointmentIds = exports.findAllAppointmentIds = function findAllAppointmentIds() {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/appointments"));
};

/*
GET     contractaccounts/{contractAccountId}/appointments
Response:
{
  "contractAccountId": "21655756747",
  "assOrderIds": [
    "000815",
    "121333"
  ]
}
*/
var getAppointmentId = exports.getAppointmentId = function getAppointmentId(contractAccountId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/contractaccounts/").concat(contractAccountId, "/appointments"));
};
var deleteAppointment = exports.deleteAppointment = function deleteAppointment(contractAccountId, assOrderId) {
  return _RestHelper.default.delete("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/contractaccounts/").concat(contractAccountId, "/appointments/").concat(assOrderId));
};

/*
Terminvorschläge für ein Vertragskonto, Auftragsnummer und Zeitraum
request:

GET /api/partner/v0/contractaccounts/{contractAccountId}/appointments/{assOrderId}/gaps?from=2022-01-11&to=2022-01-13
response:

{
    "assOrderId": "000815",
    "gaps":[
        {
            "gapId":"17",
            "isGreen":false,
            "appointment" : {
                "from":"2022-01-11T06:15:00.000Z",
                "to":"2022-01-11T09:15:00.000Z"
            }
        },
        {
            "gapId":"18",
            "isGreen":true,
            "appointment" : {
                "from":"2022-01-11T08:15:00.000Z",
                "to":"2022-01-11T011:15:00.000Z"
            }
        },
        {
            "gapId":"20",
            "isGreen":false,
            "appointment" : {
                "from":"2022-01-11T012:15:00.000Z",
                "to":"2022-01-11T15:15:00.000Z"
            }
        }
    ]
}
*/
var getAppointmentGapList = exports.getAppointmentGapList = function getAppointmentGapList(contractAccountId, assOrderId, from, to) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/contractaccounts/").concat(contractAccountId, "/appointments/").concat(assOrderId, "/gaps?from=").concat((0, _moment.default)(from).format(_GermanDateHelpers.DATE_FORMAT_NATIVE), "&to=").concat((0, _moment.default)(to).format(_GermanDateHelpers.DATE_FORMAT_NATIVE)));
};

/*
Terminvorschlag für ein Vertragskonto und Auftragsnummer setzen
request:

PUT /api/partner/v0/contractaccounts/{contractAccountId}/appointments/{assOrderId}?gap={gapId}
response: 201
*/
function saveAppointment(contractAccountId, assOrderId, gapId) {
  return _RestHelper.default.put("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/partner/v0/contractaccounts/").concat(contractAccountId, "/appointments/").concat(assOrderId, "?gapId=").concat(gapId), {}, {});
}

/*
Terminstatus für ein Vertragskonto, Auftragsnummer und Terminstatusabrufen
request:

GET /api/partner/v0/contractaccounts/{contractAccountId}/appointments/{assOrderId}/gaps/{gapId}
response:

{
	"assOrderId": "000815",
	"gapId":"17",
	"available":true
}
*/
var loadAppointmentGaps = exports.loadAppointmentGaps = function loadAppointmentGaps(contractAccountId, assOrderId, gapId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/contractaccounts/").concat(contractAccountId, "/appointments/").concat(assOrderId, "/gaps/").concat(gapId));
};

/*
Wunschtermin festlegen für ein Vertragskonto und Auftragsnummer
request:

POST /api/partner/v0/contractaccounts/{contractAccountId}/appointments/{assOrderId}
request body:

{
    "earliestDate": "2020-01-01",
    "proposals": [
        {
            "weekday": "MONDAY|TUESDAY|WEDNESDAY|THURSDAY|FRIDAY",
            "from": "hh:mm:ss",
            "to": "hh:mm:ss"
        }
    ]
}
response: 201
*/
var saveAppointmentWish = exports.saveAppointmentWish = function saveAppointmentWish(contractAccountId, assOrderId, paylod) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/contractaccounts/").concat(contractAccountId, "/appointments/").concat(assOrderId), paylod);
};